/* Tenspace Software: the little the pages need beyond HTML. Every page reads fully
   without this script; it adds the phone menu and sends the contact form. */
import site from './site.json';

/* phone menu */
const menuBtn = document.querySelector('.menu');
const menu = document.getElementById('menu');
if (menuBtn && menu) {
  menuBtn.addEventListener('click', () => {
    const open = menu.classList.toggle('open');
    menuBtn.setAttribute('aria-expanded', String(open));
  });
}

/* ── contact form → admin.10sp.us public API (contact-submit) ──
   The admin Public function owns the CRM tables and allow-lists the hosts that may post.
   Production hostnames post to production; every other host (localhost, previews, demo)
   posts to demo, so a test can never write a lead into the production CRM. */
const ADMIN_HOST = 'admin.10sp.us';
const endpoint = (env) => `https://api.${env === 'production' ? '' : `${env}.`}${ADMIN_HOST}/public/public`;
const extra = (site.environments?.production?.extra_web_hosts || '')
  .split(',').map((e) => e.split('=')[0].trim().toLowerCase()).filter(Boolean);
export const PRODUCTION_HOSTS = [...new Set([site.zone, `www.${site.zone}`, ...extra].map((h) => h.toLowerCase()))];
export const resolveEndpoint = (host = location.hostname) =>
  PRODUCTION_HOSTS.includes(String(host).toLowerCase()) ? endpoint('production') : endpoint('demo');

const FAILURE = 'We couldn\'t send that just now. Please try again, or email support@10spacesoftware.com.';
const form = document.getElementById('contactForm');
if (form) {
  let renderedAt = Date.now();
  const status = document.getElementById('contactStatus');
  const say = (text, ok) => { status.textContent = text; status.className = `status ${ok ? 'ok' : 'err'}`; };
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    form.querySelectorAll('[aria-invalid]').forEach((el) => el.removeAttribute('aria-invalid'));
    const bad = [...form.querySelectorAll('input[required], textarea[required]')].find((el) => !el.checkValidity());
    if (bad) { bad.setAttribute('aria-invalid', 'true'); bad.scrollIntoView({ block: 'center' }); bad.focus({ preventScroll: true }); say(`Please check ${bad.labels[0].textContent.replace(/\s*\(required\)/, '').toLowerCase()}.`, false); return; }
    const data = Object.fromEntries(new FormData(form).entries());
    const button = form.querySelector('button[type=submit]');
    button.disabled = true; say('Sending…', true);
    try {
      const res = await fetch(resolveEndpoint(), {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'contact-submit', payload: { ...data, renderedAt } }),
      });
      let body = {};
      try { body = await res.json(); } catch { body = {}; }
      if (!res.ok || body.ok === false) {
        const field = body.field && form.elements[body.field];
        if (field) { field.setAttribute('aria-invalid', 'true'); field.scrollIntoView({ block: 'center' }); field.focus({ preventScroll: true }); }
        say(body.message || FAILURE, false);
      } else {
        form.reset(); renderedAt = Date.now();
        say(body.message || 'Thanks, your message is on its way. A person will reply soon.', true);
      }
    } catch {
      say(FAILURE, false);
    } finally {
      button.disabled = false;
    }
  });
}
